const getBase64FileObj = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve({
        filesize: file.size,
        filetype: file.type,
        filename: file.name,
        base64: reader.result.slice(reader.result.indexOf(',') + 1),
      });
    };
    reader.onerror = error => reject(error);
  });

// eslint-disable-next-line
export { getBase64FileObj };



// WEBPACK FOOTER //
// ./src/helpers/file.js